import {ComponentType} from 'react';
import ReactDOM from 'react-dom/client';

import {Store} from '~/store/index';

export interface AppProps {
  store: Store;
}
export type AppComponentType = ComponentType<AppProps>;

export const REACT_APP_LOADING_EVENT = 'REACT_APP_LOADING_EVENT';
export const MANAGE_MENU_SHOW = 'MANAGE_MENU_SHOW';
export const MODAL_REACT_SHOW = 'MODAL_REACT_SHOW';
export const REACT_REFRESH_ACCOUNT_DATA = 'REACT_REFRESH_ACCOUNT_DATA';

interface TriggerEventProps {
  root: ReactDOM.Root;
  AppComponent: AppComponentType;
}

export type RenderTriggerEvent = CustomEvent<TriggerEventProps>;
